/* eslint-disable react/prop-types */
import { useState, useEffect } from "react";
import { Box, Grid } from "@mui/material";
import {
  BoxTicketMain, 
  BoxTitle,
  ButtonSave,
  LabelTitle,
  LabelSubtitle,
  wrapperContentTypeMusic
} from "../../assets/styles/annual-rates.style";
import SettingsService from "../../../core/services/settings.service";
import AppHelper from "../../../core/helpers/AppHelper.js";
import { useSelector } from "react-redux";
import { useUI } from "../../../core/context/ui.js";
import LoaderWidget from "../../../core/widgets/loader/loader.widget.js";
import { Form, Formik } from "formik";
import InputField from "../../../core/widgets/input.widget";
import * as Yup from 'yup';

const FitnessClass = ({props}) => {

  const [loader, setLoader] = useState(false);
  const { user } = useSelector((state) => state.user);
  const accessToken = user?.token;
  const { snackbarUI } = useUI();
  const [annualRatesData, setAnnualRatesData] = useState({});

  const settingsService = new SettingsService();

  const getAnnualRates = async () => {
    try {
      setLoader(true);
      settingsService.setAccessToken(accessToken)
      const response = await settingsService.getAnnualRatesFitnessClass();
      setAnnualRatesData(response.data)
      setLoader(false);
    } catch (e) {
      setLoader(false);
      AppHelper.checkError(e, snackbarUI);
    }
  };

  useEffect(() => {
    getAnnualRates();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { bmi, sesac, ascap, fee, gmr } = annualRatesData

  const initialValues = {
    bmiRate: bmi?.rate,
    bmiMinAnnual: bmi?.minAnnual,
    bmiMaxAnnual: bmi?.maxAnnual,
    sesacAnnual: sesac?.annual,
    ascapAnnual_1_500: ascap?.rangeA?.rates?.annual,
    ascapAnnual_501_1000: ascap?.rangeB?.rates?.annual,
    ascapAnnual_1001_1500: ascap?.rangeC?.rates?.annual,
    ascapAnnual_1501_2000: ascap?.rangeD?.rates?.annual,
    ascapAnnual_2001_3000: ascap?.rangeE?.rates?.annual,
    ascapAnnual_3001_4000: ascap?.rangeF?.rates?.annual,
    ascapAnnual_4001_15000: ascap?.rangeG?.rate,
    gmrRate: gmr?.annual,
    processing: fee?.processing,
    rightManagement: fee?.rightManagement,
  }

  const validationSchema = Yup.object().shape({
    bmiRate: Yup.string().required("Required"),
    bmiMinAnnual: Yup.string().required("Required"),
    bmiMaxAnnual: Yup.string().required("Required"),
    sesacAnnual: Yup.string().required("Required"),
    ascapAnnual_1_500: Yup.string().required("Required"),
    ascapAnnual_501_1000: Yup.string().required("Required"),
    ascapAnnual_1001_1500: Yup.string().required("Required"),
    ascapAnnual_1501_2000: Yup.string().required("Required"),
    ascapAnnual_2001_3000: Yup.string().required("Required"),
    ascapAnnual_3001_4000: Yup.string().required("Required"),
    ascapAnnual_4001_15000: Yup.string().required("Required"),
    gmrRate: Yup.string().required("Required"),
    processing: Yup.string().required("Required"),
    rightManagement: Yup.string().required("Required"),
  });

  const onSubmitBMI = async (values) => {
    const data = {
      bmi: {
        maxAnnual: values.bmiMaxAnnual,
        minAnnual: values.bmiMinAnnual,
        rate: values.bmiRate
      }
    };
    setLoader(true);
    try {
      settingsService.setAccessToken(accessToken);
      await settingsService.updateAnnualRatesFitnessClass(data);
      props.setOpenDialog(false);
    } catch (error) {
      AppHelper.checkError(error, snackbarUI);
      setLoader(false);
    }
  };

  const onSubmitSESAC = async (values) => {
    const data = {
      sesac: { annual: values.sesacAnnual }
    };
    setLoader(true);
    try {
      settingsService.setAccessToken(accessToken);
      await settingsService.updateAnnualRatesFitnessClass(data);
      props.setOpenDialog(false);
    } catch (error) {
      AppHelper.checkError(error, snackbarUI);
      setLoader(false);
    }
  };

  const onSubmitASCAP = async (values) => {
    const data = {
      ascap: {
        rangeA: { rates: { annual: values.ascapAnnual_1_500 } },
        rangeB: { rates: { annual: values.ascapAnnual_501_1000 } },
        rangeC: { rates: { annual: values.ascapAnnual_1001_1500 } },
        rangeD: { rates: { annual: values.ascapAnnual_1501_2000 } },
        rangeE: { rates: { annual: values.ascapAnnual_2001_3000 } },
        rangeF: { rates: { annual: values.ascapAnnual_3001_4000 } },
        rangeG: { rate: values.ascapAnnual_4001_15000 } }
    };
    setLoader(true);
    try {
      settingsService.setAccessToken(accessToken);
      await settingsService.updateAnnualRatesFitnessClass(data);
      props.setOpenDialog(false);
    } catch (error) {
      AppHelper.checkError(error, snackbarUI);
      setLoader(false);
    }
  };

  const onSubmitGmr = async (values) => {
    const data = {
      gmr: {
        annual: values.gmrRate
      }
    };
    setLoader(true);
    try {
      settingsService.setAccessToken(accessToken);
      await settingsService.updateAnnualRatesFitnessClass(data);
      props.setOpenDialog(false);
    } catch (error) {
      AppHelper.checkError(error, snackbarUI);
      setLoader(false);
    }
  };
  
  const onSubmitFee = async (values) => {
    const data = {
      fee: {
        processing: values.processing,
        right_management: values.rightManagement
    }
    };
    setLoader(true);
    try {
      settingsService.setAccessToken(accessToken);
      await settingsService.updateAnnualRatesFitnessClass(data);
      props.setOpenDialog(false);
    } catch (error) {
      AppHelper.checkError(error, snackbarUI);
      setLoader(false);
    }
  };

  return (
    <Grid container>

      <Grid item md={12} sx={wrapperContentTypeMusic}>
        <BoxTicketMain>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmitBMI}
            enableReinitialize={true}
          >
            {(props) => {
              // eslint-disable-next-line no-unused-vars
              const { values, handleChange } = props
              return (
                <Form id={1} component="form" style={{ width: "100%" }}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <BoxTitle>BMI</BoxTitle>
                    <ButtonSave color='primary' type='submit'>Save Changes</ButtonSave>
                  </Box>
                  <Grid container sx={{ marginTop: "2em" }}>
                    <Grid item xs={4}>
                      <Box>
                        <LabelTitle>Annual Rate</LabelTitle>
                        <LabelSubtitle>Per total members</LabelSubtitle>
                        <InputField
                          name="bmiRate"
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={4}>
                      <Box>
                        <LabelTitle>Minimum Annual Rate</LabelTitle>
                        <LabelSubtitle>Per total members</LabelSubtitle>
                        <InputField
                          name="bmiMinAnnual"
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={4}>
                      <Box>
                        <LabelTitle>Maximun Annual Rate</LabelTitle>
                        <LabelSubtitle>Per total members</LabelSubtitle>
                        <InputField
                          name="bmiMaxAnnual"
                        />
                      </Box>
                    </Grid>
                  </Grid>
                </Form>
              )
            }
            }
          </Formik>
        </BoxTicketMain>
        <BoxTicketMain>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmitSESAC}
            enableReinitialize={true}
          >
            <Form id={2} component="form" style={{ width: "100%" }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <BoxTitle>SESAC</BoxTitle>
                <ButtonSave color='primary' type='submit'>Save Changes</ButtonSave>
              </Box>
              <Grid container sx={{ marginTop: "2em" }}>
                <Grid item xs={12}>
                  <Box sx={{ display: "flex" }}>
                    <Box sx={{ paddingRight: "2em" }}>
                      <LabelTitle>Annual Rate</LabelTitle>
                      <LabelSubtitle>Per total members</LabelSubtitle>
                    </Box>
                    <InputField
                      name="sesacAnnual"
                    />
                  </Box>
                </Grid>
              </Grid>
            </Form>
          </Formik>
        </BoxTicketMain>
        <BoxTicketMain>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmitASCAP}
            enableReinitialize={true}
          >
            <Form id={3} component="form" style={{ width: "100%" }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <BoxTitle>ASCAP</BoxTitle>
                <ButtonSave color='primary' type='submit'>Save Changes</ButtonSave>
              </Box>
              <Grid container sx={{ marginTop: "2em" }}>
                <Grid item xs={12}>
                  <Box sx={{marginBottom: '50px'}}>
                    <LabelTitle>Total group class participants</LabelTitle>
                  </Box>
                </Grid>
                <Grid item xs={4}>
                  <Box>
                    <LabelSubtitle>From 1 to 500</LabelSubtitle>
                    <InputField
                      name="ascapAnnual_1_500"
                    />
                  </Box>
                </Grid>
                <Grid item xs={4}>
                  <Box>
                    <LabelSubtitle>From 501 to 1000</LabelSubtitle>
                    <InputField
                      name="ascapAnnual_501_1000"
                    />
                  </Box>
                </Grid>
                <Grid item xs={4}>
                  <Box>
                    <LabelSubtitle>From 1001 to 1500</LabelSubtitle>
                    <InputField
                      name="ascapAnnual_1001_1500"
                    />
                  </Box>
                </Grid>
                <Grid item xs={4}>
                  <Box>
                    <LabelSubtitle>From 1501 to 2000</LabelSubtitle>
                    <InputField
                      name="ascapAnnual_1501_2000"
                    />
                  </Box>
                </Grid>
                <Grid item xs={4}>
                  <Box>
                    <LabelSubtitle>From 2001 to 3000</LabelSubtitle>
                    <InputField
                      name="ascapAnnual_2001_3000"
                    />
                  </Box>
                </Grid>
                <Grid item xs={4}>
                  <Box>
                    <LabelSubtitle>From 3001 to 4000</LabelSubtitle>
                    <InputField
                      name="ascapAnnual_3001_4000"
                    />
                  </Box>
                </Grid>
                <Grid item xs={4}>
                  <Box>
                    <LabelSubtitle>From 4001 per participant</LabelSubtitle>
                    <InputField
                      name="ascapAnnual_4001_15000"
                    />
                  </Box>
                </Grid>
              </Grid>
            </Form>
          </Formik>
        </BoxTicketMain>
        <BoxTicketMain>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmitGmr}
            enableReinitialize={true}
          >
            <Form id={3} component="form" style={{ width: "100%" }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <BoxTitle>GMR</BoxTitle>
                <ButtonSave color='primary' type='submit'>Save Changes</ButtonSave>
              </Box>
              <Grid container sx={{ marginTop: "2em" }}>
                <Grid item xs={12}>
                  <Box sx={{ display: "flex" }}>
                    <Box sx={{ paddingRight: "2em" }}>
                      <LabelTitle>Rate</LabelTitle>
                    </Box>
                    <InputField
                      name="gmrRate"
                    />
                  </Box>
                </Grid>
              </Grid>
            </Form>
          </Formik>
        </BoxTicketMain>
      </Grid>

      <Grid item md={12}>
        <BoxTicketMain>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmitFee}
            enableReinitialize={true}
          >
            <Form id={4} component="form" style={{ width: "100%" }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <BoxTitle>Processing Fee</BoxTitle>
                <ButtonSave color='primary' type='submit'>Save Changes</ButtonSave>
              </Box>
              <Grid container sx={{ marginTop: "2em" }}>
                <Grid item xs={8}>
                  <Box sx={{ display: "flex" }}>
                    <InputField
                      fullWidth
                      name="processing"
                      label="%"
                      InputLabelProps={{ shrink: true }}
                    />
                  </Box>
                </Grid>
              </Grid>
            </Form>
          </Formik>
        </BoxTicketMain>
        <BoxTicketMain>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmitFee}
            enableReinitialize={true}
          >
            <Form id={5} component="form" style={{ width: "100%" }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <BoxTitle>Right Managements Fee</BoxTitle>
                <ButtonSave color='primary' type='submit'>Save Changes</ButtonSave>
              </Box>
              <Grid container sx={{ marginTop: "2em" }}>
                <Grid item xs={8}>
                  <Box sx={{ display: "flex" }}>
                    <InputField
                      fullWidth
                      name="rightManagement"
                      label="%"
                      InputLabelProps={{ shrink: true }}
                    />
                  </Box>
                </Grid>
              </Grid>
            </Form>
          </Formik>
        </BoxTicketMain>
      </Grid>

      <LoaderWidget loader={loader} />
    </Grid>
  )
}

export default FitnessClass;